// Generated by ts-to-zod
import { z } from 'zod';

export const cancelAnnotationPayloadSchema = z.object({
  proccessingDuration: z.unknown().optional(),
});
